import { analyticsRepository } from "@/repositories/analytics";
import { useStore } from "@/stores/useStore";
import { useCallback } from "react";

const OverdueTaskToastEventNames = {
  toastShown: "overdue_task_toast_shown",
  actionClicked: "overdue_task_toast_action_clicked",
} as const;

type OverdueTaskToastEventNames =
  (typeof OverdueTaskToastEventNames)[keyof typeof OverdueTaskToastEventNames];

export const useOverdueTaskToastAnalytics = () => {
  const shopId = useStore((s) => s.shopId);

  const analyticsWrapper = useCallback(
    (
      eventName: OverdueTaskToastEventNames,
      params?: Record<string, unknown>
    ) => {
      if (!shopId) {
        console.error(
          "Shop ID is missing, cannot log analytics event:",
          eventName
        );
        return;
      }
      analyticsRepository.logAnalyticsEvent(eventName, { ...params, shopId });
    },
    [shopId]
  );

  const logToastShown = (mode: "single" | "digest") => {
    analyticsWrapper(OverdueTaskToastEventNames.toastShown, { mode });
  };

  const logMarkCompleteClicked = () => {
    analyticsWrapper(OverdueTaskToastEventNames.actionClicked);
  };

  return { logToastShown, logMarkCompleteClicked };
};
